<template>
  <el-form :inline="true" :model="queryParam" class="mainSearch">
    <el-form-item label="类目名称">
      <el-input v-model="queryParam.name" placeholder="输入一级类目名称" />
    </el-form-item>
    <!-- <el-form-item label="父栏目">
          <el-tree-select
            style="width: 100%"
            v-model="queryParam.parentid"
            :data="tableData"
            check-strictly
            :render-after-expand="false"
            :props="props"
          >
          </el-tree-select>
        </el-form-item> -->
    <el-form-item label="状态">
      <el-select v-model="queryParam.status" placeholder="类目状态">
        <el-option label="正常" :value="1"/>
        <el-option label="停用" :value="2"/>
      </el-select>
    </el-form-item>

    <el-form-item>
      <el-button type="danger" @click="getListCatalog">查询</el-button>
      <el-button @click="resetSearch">重置</el-button>
    </el-form-item>
  </el-form>
  <el-row>
    <el-col :span="24">
      <div class="mainTableTop">
        <el-button
          type="danger"
          @click="(dialog = true), doCatalogAdd()"
          v-hasPermission="['catalog:add']"
          >添加类目</el-button>
          <el-button
          type="danger"
          :loading="loadingexport" @click="doExportCatalog"
          v-hasPermission="['catalog:export']"
          >{{loadingexport ? "处理中 ..." : "导出类目"}}</el-button
        >
      </div>
    </el-col>
  </el-row>

  <el-row class="mainTableBox">
    <el-col :span="24" class="mpadding">
  <el-table
    :data="filterTableData"
    v-loading="loadingData"
    class="mainTable"
    default-expand-all
    row-key="catalogid"
  >
    <el-table-column label="名称" prop="name" />
    <!-- <el-table-column label="描述" prop="desc" width="250" /> -->
    <el-table-column label="状态" align="center" prop="status">
      <template #default="scope">
        <el-tag
          round
          :type="scope.row.status === 1 ? 'success' : 'danger'"
          disable-transitions
          ><span v-text="util.showDelflag(scope.row.status)"></span>
        </el-tag>
      </template>
    </el-table-column>
    <el-table-column label="操作" fixed="right" width="160">
      <template #default="scope">
        <el-link
          type="primary"
          size="small"
          @click="(dialog = true), doCatalogEdit(scope.$index, scope.row)"
          v-hasPermission="['catalog:edit']"
          >编辑</el-link
        >
        <el-popconfirm
              confirm-button-type="danger"
              confirm-button-text="确定"
              cancel-button-text="取消"
              icon-color="#626AEF"
              title="您确定要删除吗？"
              width="200px"
              @confirm="doCatalogDelete(scope.$index, scope.row)"
            >
              <template #reference>
                <el-link
                 v-hasRole="['admin']"
                  size="small"
                  type="danger"
                  >删除</el-link
                >
              </template>
            </el-popconfirm>

      </template>
    </el-table-column>
  </el-table>
  </el-col>
  </el-row>

  <el-row class="mainTableBottom">
    <el-col :span="8"><div>
        <!-- <el-button
          type="danger"
          >添加用户</el-button> -->
      </div></el-col>
    <el-col :span="16">
      <div style="float: right">
        <el-pagination
          :hide-on-single-page="true"
          v-model:page-size="queryParam.pageSize"
          :page-sizes="[10, 15, 20, 30]"
          :background="true"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="changeChangeSize"
          @current-change="changePage"
        />
      </div>
    </el-col>
  </el-row>

  <el-drawer
    ref="drawerRef"
    v-model="dialog"
    :title="title"
    direction="rtl"
    :close-on-click-modal="false"
    size="45%"
    @close="doCatalogClose"
  >
    <div class="common-drawer__content">
      <el-form
        ref="catalogFormRef"
        :model="catalogForm"
        :rules="rules"
        label-width="120px"
      >
        <el-form-item label="父栏目">
          <el-tree-select
            style="width: 100%"
            v-model="catalogForm.parentid"
            :data="tableAllData"
            check-strictly
            :render-after-expand="false"
            :props="props"
          >
          </el-tree-select>
        </el-form-item>
        <el-form-item label="名称" prop="name">
          <el-input
            v-model.trim="catalogForm.name"
            placeholder="请输入类目名称"
          />
        </el-form-item>
        <!-- <el-form-item label="描述" prop="desc">
          <el-input
            v-model.trim="catalogForm.desc"
            placeholder="请输入类目描述"
          />
        </el-form-item> -->
        <el-form-item label="状态" prop="status">
          <el-radio-group v-model="catalogForm.status">
            <el-radio :label="1">启用</el-radio>
            <el-radio :label="2">停用</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- <el-form-item label="排序" prop="sort">
          <el-input-number
            v-model="catalogForm.sort"
            :min="0"
            :max="100"
            placeholder="排序值"
          />
        </el-form-item> -->
      </el-form>
      <div class="common-drawer__footer">
        <el-button @click="doCatalogClose">关闭</el-button>
        <el-button
          type="danger"
          :loading="loading"
          @click="doCatalogSave"
          >{{ loading ? "提交中 ..." : "提交" }}</el-button
        >
      </div>
    </div>
  </el-drawer>

</template>
  
<script setup>
import { ref, onMounted, computed } from "vue";
import { ElDrawer, ElTable, ElMessage } from "element-plus";
import {
  listCatalog,
  saveCatalog,
  exportCatalog,
  deleteCatalog,
} from "@/api/catalog";

import util from "@/util/tool.js";

let timer;

let dialog = ref(false);
const loading = ref(false);
const loadingexport = ref(false);
const loadingData = ref(true);

const drawerRef = ref(ElDrawer);

const catalogFormRef = ref();

const total = ref(0);
const pageSize = ref(2000); //每页显示条数

const props = ref({
  checkStrictly: true,
  value: "catalogid",
  label: "name",
});
// const value = ref()

let title = ref("添加类目");

//搜索查询
const queryParam = ref({
  pageNo: 1,
  pageSize: pageSize.value,
  name: '',
  status: '',
  parentid: null,
});
const resetSearch = () => {
  queryParam.value = {
    pageNo: 1,
    pageSize: pageSize.value,
    name: '',
    status: '',
    parentid: null,
  };
  getListCatalog();
};

const catalogForm = ref({
  catalogid: null,
  parentid: null,
  name: '',
  icon: '',
  ename: '',
  path: '',
  component: '',
  sort: 0,
  status: 1,
  nav: 1,
});

const tableData = ref([]);
const tableAllData = ref([]);

// const parentDataList = ref([]);
// const parentData = (data) => {
//   let tmpData = data.filter((cdata) => cdata.parentid == 0);

//   let tmpNewData = [];
//   for (let i = 0; i < tmpData.length; i++) {
//     tmpNewData.push({
//       catalogid: tmpData[i].catalogid.toString(),
//       name: tmpData[i].name,
//       ename: tmpData[i].ename,
//     });
//   }
//   return tmpNewData;
// };

const search = ref("");
const filterTableData = computed(() => {
  // return tableData.value.filter(
  //   (data) =>
  //     !queryParam.value.name ||
  //     data.name.toLowerCase().includes(queryParam.value.name.toLowerCase())
  // );
  return tableData.value.filter(
    (data) =>
      !search.value ||
      data.name.toLowerCase().includes(search.value.toLowerCase())
  );
});

const catalogReset = (perms) => {
  let dataTmp = [];
  perms.forEach((perm) => {
    // console.log(perm);
    perm.catalogid = perm.catalogid.toString();
    perm.parentid = perm.parentid.toString();
    dataTmp.push(perm);
    catalogReset(perm.children);
  });
  return dataTmp;
};

//onMounted方法
onMounted(() => {
  getListCatalog();

  setTimeout(() => {
    let tmpData = JSON.parse(JSON.stringify(tableData.value)); 
    tableAllData.value = tmpData
    console.log(tableAllData)
  }, 1000);
  

});

const doCatalogAdd = () => {
  title.value = "新增类目";
  resetForm();
  // catalogFormRef.value.resetFields();
  // catalogForm.value.catalogid = null;
};

const doCatalogEdit = (index, obj) => {
  title.value = "编辑类目";
  // console.log(obj.nav, obj.name);
  // catalogForm.value = obj;//直接赋值会出问题
  catalogForm.value = {
    catalogid: obj.catalogid,
    parentid: obj.parentid ? obj.parentid.toString() : null,
    name: obj.name,
    status: obj.status,
  };
};
// const doCatalogDelete = (index, obj) => {
//   deleteCatalog(obj).then((res) => {
//     if (res.data.code === 1) {
//       getListCatalog();
//     } else {
//       ElMessage.error(res.data.msg);
//     }
//   });
// };

const doCatalogClose = () => {
  loading.value = false;
  dialog.value = false;
  clearTimeout(timer);
  catalogFormRef.value.resetFields()
};

const resetForm = () => {
  catalogForm.value = {
    catalogid: null,
    parentid: null,
    name: '',
    status: 1,
  };
};

const doCatalogSave = () => {
  catalogFormRef.value.validate((valid) => {
    if (!valid) {
      //ElMessage("请先完善表单数据填写！");
      return;
    }

    saveCatalog(catalogForm.value).then((res) => {
      loading.value = true;
      timer = setTimeout(() => {
        // 动画关闭需要一定的时间
        setTimeout(() => {
          loading.value = false;
        }, 400);
        if (res.data.code === 1) {
          getListCatalog();
          doCatalogClose();
        } else {
          ElMessage.error(res.data.msg);
        }
      }, 1000);
    });
  });
};

//关闭用户表单弹出框
// const doDrawerClose = (done) => {
//   if (loading.value) {
//     return;
//   }
//   ElMessageBox.confirm("您确定要提交表单数据吗？", {
//     distinguishCancelAndClose: true,
//     confirmButtonText: "确定提交",
//     cancelButtonText: "取消",
//   })
//     .then(() => {
//       loading.value = true;
//       timer = setTimeout(() => {
//         done();
//         // 动画关闭需要一定的时间
//         setTimeout(() => {
//           loading.value = false;
//         }, 400);
//       }, 1000);
//     })
//     .catch(() => {
//       // catch error
//     });
// };


const doCatalogDelete = (index, obj) => {
  deleteCatalog(obj).then((res) => {
    if (res.data.code === 1) {
      getListCatalog();
    } else {
      ElMessage.error(res.data.msg);
    }
  });
};

//分页
const changePage = (current) => {
  queryParam.value.pageNo = current;
  getListCatalog();
};
const changeChangeSize = (size) => {
  pageSize.value = size;
  queryParam.value.pageSize = size;
  getListCatalog();
};

//类目表API
const getListCatalog = () => {
  listCatalog(queryParam.value).then((res) => {
    total.value = res.data.extend.pages.total;
    queryParam.value.pageSize = pageSize.value;
    // parentDataList.value = parentData(tableData.value);
    //重新封装
    tableData.value = catalogReset(res.data.extend.pages.list);
    loadingData.value = false
  });
};

// const getListCatalogAll = () => {
//   listCatalog({pageNo: 1, pageSize: 2000}).then((res) => {    
//     tableAllData.value = catalogReset(res.data.extend.pages.list);
//   });
// }


const doExportCatalog = () => {
  if (tableData.value.length<=0) {
    ElMessage.error("无导出的数据!")
    return
  }
  let query = JSON.parse(JSON.stringify(queryParam.value)); 
  query.pageSize = 5000

  loadingexport.value = true;
  exportCatalog(query).then((response) => {//queryParam.value
    downloadExcel(response);
  });
};

const downloadExcel = (response) => {
  timer = setTimeout(() => {
    // 动画关闭需要一定的时间
    setTimeout(() => {
      loadingexport.value = false;
    }, 400);
    //下载
    const content = response.data;
    const blob = new Blob([content], {
      type: "application/application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const downloadElement = document.createElement("a");
    const href = window.URL.createObjectURL(blob);
    downloadElement.href = href;
    downloadElement.download = decodeURI(response.headers["filename"]);
    document.body.appendChild(downloadElement);
    downloadElement.click();
    document.body.removeChild(downloadElement); //下载完成移除元素
    window.URL.revokeObjectURL(href); //释放掉blob对象
  }, 1000);
};

//表单验证规则
const rules = ref({
  name: [
    {
      required: true,
      message: "请输入名称",
      trigger: "blur",
    },
    {
      min: 2,
      max: 10,
      message: "名称长度2到10",
      trigger: "blur",
    },
  ],
});
</script>